import { Component, OnInit, Input, SimpleChanges } from "@angular/core";

import { AskGenAiService } from "src/app/askGenAi.service";
import { ExportService } from "src/app/export.service";

@Component({
  selector: "app-iqgen-output",
  templateUrl: "./iqgen-output.component.html",
  styleUrls: ["./iqgen-output.component.css"],
})
export class IqgenOutputComponent implements OnInit {
  @Input() response: any = "";
  showResponse = false;
  isLoading = false;
  isCopied: boolean = false;
  waitingMessage = false;
  markdown: string;
  // output: string;

  constructor(
    private exportService: ExportService // private askGenAi: AskGenAiService
  ) {
    // this.askGenAi.response.subscribe((data) => {
    //   if (data) {
    //     this.output = data.model_responses[0];
    //     console.warn(this.output);
    //     this.showResponse = true;
    //   }
    // })
  }

  ngOnInit(): void {}

  copyHtml() {
    const richText = document.getElementById("downloadableContent").innerHTML;
    const blobHtml = new Blob([richText], { type: "text/html" });
    const data = [
      new ClipboardItem({
        ["text/html"]: blobHtml,
      }),
    ];

    navigator.clipboard.write(data).then(
      () => {
        this.isCopied = true;
      },
      () => {}
    );
  }

  ngOnChanges(): void {
    if (this.response) {
      this.markdown = this.response;
      this.showResponse = true;
    }
  }

  exportAsPdf() {
    let opt = {
      margin: 1,
      filename: "myfile.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "cm", format: "letter", orientation: "portrait" },
    };

    this.exportService.exportAsPdf("downloadableContent", opt);
  }
}
